import { CollectionView } from 'backbone.marionette';
import UpcomingFixturesStatRow from '../UpcomingFixturesStatRow';

export class UpcomingFixturesStatsTable extends CollectionView {
	get childView() {
		return UpcomingFixturesStatRow;
	}

	get childViewOptions() {
		return {
			has_assistant_coach: this.model.get( 'has_assistant_coach' )
		};
	}
}

export default UpcomingFixturesStatsTable;